export const ThemeList = {
  BankNizwa: "banknizwa",

  Green: "green",
  Blue: "blue",
  Gray: "gray",
  White: "white",
};
